import { Suspense }  from 'react';
import  { BrowserRouter, Routes, Route } from 'react-router-dom'
import './App.css';

import MainPage from '../src/pages/MainPage.js'
import RegisterPage from '../src/pages/RegisterPage.js'
import ConfirmationPage from '../src/pages/ConfirmationPage.js'

function App() {
  return (
  <Suspense  fallback="loading">
    <BrowserRouter>
      <Routes>

        <Route exact path="/" element={<MainPage />} />
        <Route exact path="/form" element={<RegisterPage />} />
        <Route exact path="/confirm" element={<ConfirmationPage />} />
        
      </Routes>
    </BrowserRouter>
  </Suspense>

  );
}

export default App;
